module.exports = __webpack_public_path__ + "static/media/bg.a18039ea.jpg";